import { NavLink } from 'react-router-dom'
import { haptics } from '../lib/telegram.js'
import styles from './TabBar.module.css'

/**
 * Four tabs, always reachable. The session player is the only screen allowed to
 * hide this — study is a focus mode (CLAUDE.md > Screens & navigation).
 */
const TABS = [
  { to: '/', label: 'Сегодня', icon: '◎' },
  { to: '/words', label: 'Слова', icon: '≡' },
  { to: '/duels', label: 'Дуэли', icon: '⚔' },
  { to: '/stats', label: 'Статистика', icon: '▲' },
] as const

export function TabBar() {
  return (
    <nav className={styles.bar}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.to === '/'}
          onClick={() => haptics.tap()}
          className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
        >
          <span className={styles.icon} aria-hidden="true">
            {tab.icon}
          </span>
          <span className={styles.label}>{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
